
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer/[referralCode]/playlist/[...slug]",
      function () {
        return require("private-next-pages/refer/[referralCode]/playlist/[...slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer/[referralCode]/playlist/[...slug]"])
      });
    }
  